import React from 'react';
import DefaultTabTextLogo from './DefaultTabTextLogo';
import DefaultTabSearchInput from './DefaultTabSearchInput';
import DefaultTabAddTile from './DefaultTabAddTile';

export default function DefaultTabContent({ title, bgClass, searchPlaceholder = "Search by my skills", children }) {
  return (
    <div className={`page-content ${bgClass}`}>
      <DefaultTabTextLogo
        label={title}
      />
      <DefaultTabSearchInput
        text={searchPlaceholder}
      />
      <div id="most-visited">
        <div id="mv-tiles">
          {children}
          <DefaultTabAddTile title="Add skill" tabIndex={1}/>
        </div>
      </div>
    </div>
  );
}
